module.exports = __webpack_public_path__ + "assets/img/6583ea6c60b4e49c9f9e5dcab4ba2f20.svg";